import { render } from "./TheContentHeader.vue?vue&type=template&id=3edab38a"
import script from "./TheContentHeader.vue?vue&type=script&lang=js"
export * from "./TheContentHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__